(ns client-portal.client.account.data
  (:require [client-portal.client.routes :as routes]
            [clojure.string :as s]
            [shared.core.reactive :as re]
            [shared.core.account.data :as account.d]
            [shared.core.util :as util]))

(re/reg-sub
  :account/core-route-access-
  :<- [:account/user-roles-]
  (fn [roles]
    (let [location-origin (.. js/document -location -origin)]
      (when-not (util/loading? roles)
        (filterv #(when % (account.d/has-route-access? routes/routes % roles))
                 [:vi
                  :vc
                  :conversations/list
                  :drive-thru/locations-list])))))

(re/reg-sub
  :account/core-route-access-set-
  :<- [:account/core-route-access-]
  (fn [core-route-access]
    (some->> core-route-access (into #{}))))

(re/reg-sub
  :account/multi-core-route-access?-
  :<- [:account/core-route-access-]
  (fn [core-route-access]
    (some-> core-route-access (count) (> 1))))

(re/reg-event-db
  :account/go-to-login re/middleware
  (fn [db]
    (re/dispatch [:router/go [:home]])
    db))
